import { LeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Routes } from 'business/router/constants';
import { useNavigate } from 'react-router';

export const Header = ({ title }: { title: string }) => {
  const navigate = useNavigate();

  return (
    <header className="flex w-full justify-between bg-white px-4 py-2">
      <Button
        icon={<LeftOutlined className="text-primary text-xl" />}
        type="link"
        onClick={() => navigate(Routes.App)}
        aria-label="Retour"
      />
      <h1 className="text-primary text-xl font-bold">{title}</h1>
      <div className="w-10" />
    </header>
  );
};
